import grapesjs from 'drapcode-builder';
import loadTraits from './traits';

export default grapesjs.plugins.add('drapcode-collection-audio-traits', (editor, opts) => {
  const default_traits = {
    link: {
      type: 'drapcode-audio',
      label: false,
    },
  };
  let options = {
    ...{
      traits: default_traits,
    },
    ...opts,
  };
  loadTraits(editor, options);
});
